import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.8067 3.75426C14.0667 4.01426 14.0667 4.43426 13.8067 4.69426L12.5867 5.91426L10.0867 3.41426L11.3067 2.19426C11.4312 2.06942 11.6003 1.99927 11.7767 1.99927C11.953 1.99927 12.1221 2.06942 12.2467 2.19426L13.8067 3.75426ZM2 13.6676V11.6409C2 11.5476 2.03333 11.4676 2.1 11.4009L9.37333 4.12759L11.8733 6.62759L4.59333 13.9009C4.53333 13.9676 4.44667 14.0009 4.36 14.0009H2.33333C2.14667 14.0009 2 13.8543 2 13.6676Z",
		fill: "currentColor"
	})
});
export default SvgPencil;
